import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import ConfigurazioneMenu from './ConfigurazioneMenu';
import ConfigurazioneSpostaAttivita from './ConfigurazioneSpostaAttivita';
import ComandiServerList from './ComandiServerList';

class ConfigurazioneContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/configurazione' render={() => (
          <Redirect
              to='/app/configurazione/menu'
          />
      )} />
      <MatchWhenLoggedIn path='/app/configurazione/menu' component={ConfigurazioneMenu} />
      <MatchWhenLoggedIn path='/app/configurazione/spostaattivita' component={ConfigurazioneSpostaAttivita} />
      <MatchWhenLoggedIn path='/app/configurazione/comandiserver' component={ComandiServerList} />
    </div>)
  }
}

export default ConfigurazioneContent;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ConfigurazioneContent.js
 **/